import api from "services/api";
import { getAccessToken } from "services/accessTokenServices";
import { toast } from "react-toastify";

type UpdatePassword = {
  token?: string;
  password: string;
  newPassword: string;
  newPasswordConfirmation: string;
};

export const updatePassword = async (
  props: UpdatePassword
): Promise<boolean | void> => {
  const accessToken = (await getAccessToken()) || "";

  const headers = {
    "Content-Type": "application/json",
    access_token: accessToken,
  };

  const userId = await localStorage.getItem("@UltragazEmpresarial:userId");

  const body = {
    ...props,
  };

  try {
    const response = await api.put(
      `industrial/customer/v1/users/${userId}/passwords`,
      body,
      {
        headers,
      }
    );

    const { status } = response;
    if (status === 204) return true;
    return false;
  } catch (error) {
    const { message } = error.response.data;
    toast.error(message);
    return false;
  }
};
